{
  "FEEDBACK": {
    "TOOLTIPS": {
      "HAPPY": "I like this feature",
      "NEUTRAL": "This feature is OK",
      "SAD": "I don't like this feature"
    },
    "PLEASE_LEAVE_FEEDBACK": "Please leave some feedback on this feature",
    "REMIND_ME_LATER": "Remind me later",
    "PLEASE_MAKE_SELECTION": "Please make a selection",
    "MESSAGE_PLACEHOLDER": "Feedback (Optional)",
    "DIALOG_TITLE": "Please leave some feedback about this feature",
    "PLEASE_GIVE_US_SOME_FEEDBACK": "Please leave some feedback on this feature",
    "YOU_WILL_BE_REMINDED": "You will be reminded in {{days}} days."
  }
}
